import "@/App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Courses from "@/pages/Courses";
import CourseDetail from "@/pages/CourseDetail";
import CategoryPage from "@/pages/CategoryPage";
import CareerPrograms from "@/pages/CareerPrograms";
import Bvoc from "@/pages/Bvoc";
import Tally from "@/pages/Tally";
import Pathways from "@/pages/Pathways";
import Internship from "@/pages/Internship";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Events from "@/pages/Events";
import Verify from "@/pages/Verify";
import Apply from "@/pages/Apply";
import CareerAI from "@/pages/CareerAI";
import Login from "@/pages/auth/Login";
import Register from "@/pages/auth/Register";
import ForgotPassword from "@/pages/auth/ForgotPassword";
import ResetPassword from "@/pages/auth/ResetPassword";
import Portal from "@/pages/Portal";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminApplications from "@/pages/admin/AdminApplications";
import AdminCourses from "@/pages/admin/AdminCourses";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/courses/category/:slug" element={<CategoryPage />} />
        <Route path="/course/:slug" element={<CourseDetail />} />
        <Route path="/career-programs" element={<CareerPrograms />} />
        <Route path="/wilp-bvoc" element={<Bvoc />} />
        <Route path="/tally-education" element={<Tally />} />
        <Route path="/career-pathways" element={<Pathways />} />
        <Route path="/internship" element={<Internship />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/events" element={<Events />} />
        <Route path="/verify" element={<Verify />} />
        <Route path="/verify/:certId" element={<Verify />} />
        <Route path="/admissions" element={<Apply />} />
        <Route path="/apply" element={<Apply />} />
        <Route path="/career-ai" element={<CareerAI />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/portal" element={<ProtectedRoute><Portal /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute roles={["admin", "counsellor"]}><AdminLayout /></ProtectedRoute>}>
          <Route index element={<AdminDashboard />} />
          <Route path="leads" element={<AdminLeads />} />
          <Route path="applications" element={<AdminApplications />} />
          <Route path="courses" element={<AdminCourses />} />
        </Route>
        <Route path="*" element={<Home />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App bg-navy-base min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" richColors theme="dark" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
